import { Injectable, inject } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { ApiResponse } from '@interfaces/response';
import { Observable } from 'rxjs';
import { Qrcode } from '@interfaces/qrcode';
import { Technician } from '@interfaces/technician';

@Injectable({
  providedIn: 'root'
})
export class TechnicianApiService {

  private api_service = inject(ApiService);

  private technician_list_url: string = '/users/technician';
  private qr_code_url: string = '/users/qrcode';
  private techinician_create_retrieve_url: string = '/users/technician';
  private send_qrcode_email_url: string = '/users/send_qrcode_email';

  constructor() { }

  public get_technicians_list_data(params?: any, showLoader: boolean = true): Observable<ApiResponse<Technician[]>> {
    return this.api_service.get<ApiResponse<Technician[]>>(this.technician_list_url, params, undefined, showLoader);
  }

  public get_qrcode(technician_id: number): Observable<ApiResponse<Qrcode>> {
    const url = `${this.qr_code_url}/${technician_id}`;
    return this.api_service.get<ApiResponse<Qrcode>>(url);
  }

  // role: field technician, remote technician or (superadmin only) backoffice; a backoffice can come with a new company
  public add_technician(name:string, lastname:string, email:string, company:string, phone:string, prefix:string,
                        role?: number, newCompany?: { name: string, vat: string }): Observable<ApiResponse<Technician>> {
    const body: Record<string, any> = {
      "name": name,
      "lastname": lastname,
      "email": email,
      "company": company || null,
      "phone": phone,
      "prefix": prefix
    }
    if (role) {
      body["role"] = role;
    }
    if (newCompany) {
      body["new_company_name"] = newCompany.name;
      body["new_company_vat"] = newCompany.vat;
      delete body["company"];
    }
    if (!body["company"]) {
      delete body["company"];
    }
    return this.api_service.post<ApiResponse<Technician>>(this.techinician_create_retrieve_url, body);
  }

  public update_technician(id:number, name:string, lastname:string, email:string, company:string, phone:string, prefix:string,
                           role?: number): Observable<ApiResponse<Technician>> {
    const url = `${this.techinician_create_retrieve_url}/${id}`;
    const body: Record<string, any> = {
      "name": name,
      "lastname": lastname,
      "email": email,
      "company": company,
      "phone": phone,
      "prefix": prefix
    }
    if (role) {
      body["role"] = role;
    }
    return this.api_service.put<ApiResponse<Technician>>(url, body);
  }

  public delete_technician(id: number): Observable<ApiResponse<null>> {
    const url = `${this.techinician_create_retrieve_url}/${id}`;
    return this.api_service.delete<ApiResponse<null>>(url);
  }

  public send_qrcode_email(emails: string[], ccEmails: string[], qrCode: string): Observable<ApiResponse<Qrcode>> {
    const body = {
      emails: emails,
      cc_emails: ccEmails,
      qr_code: qrCode
    };
    return this.api_service.post<ApiResponse<Qrcode>>(this.send_qrcode_email_url, body);
  }
}
